import { EFEITO_LABEL, type EfeitoRegulatorio } from "../types";

/** Ícone do efeito regulatório tônico derivado (acalmar↔ativar). */
const ICONE: Record<EfeitoRegulatorio, string> = {
  acalma: "↓",
  ativa: "↑",
  regula: "≈",
  variavel: "↕",
  poucos_dados: "·",
};

/**
 * Rótulo do efeito regulatório de uma atividade. Inline e calmo (classe .tend);
 * `forte` realça em verde suave para o detalhe/kit.
 */
export function EfeitoBadge({
  efeito,
  forte = false,
}: {
  efeito: EfeitoRegulatorio;
  forte?: boolean;
}) {
  return (
    <span className={forte ? "efeito-forte" : "tend"}>
      <span aria-hidden>{ICONE[efeito]}</span> {EFEITO_LABEL[efeito]}
    </span>
  );
}
